import React from 'react';
import { Grid } from '@mui/material';

import {
	BooleanDescField,
	CurrencyTextField,
	NumberTextField,
	TagsSelectField,
	useSettings
} from 'app/main/components';
import { type DetailsSectionInfoContentProps } from 'app/main/components/page-layouts';

export default function WorkReportsDetailsSectionSecondaryInfo(props: DetailsSectionInfoContentProps) {
	const { t } = useSettings();

	return (
		<>
			<Grid size={{ lg: 3, xs: 12 }}>
				{/* OTHER EXPENSES */}
				<CurrencyTextField
					name="wore_expenses_other"
					label={t('DETAILS_WORKREPORTS_FIELD_EXPENSES')}
					value={props.model.wore_expenses_other}
					isEdit={props.isEdit}
					logProps={props.logProps}
					sendChange={props.sendChange}
				/>
			</Grid>
			<Grid size={{ lg: 3, xs: 12 }}>
				{/* KM */}
				<NumberTextField
					name="wore_km"
					label={t('DETAILS_WORKREPORTS_FIELD_KM')}
					value={props.model.wore_km}
					isEdit={props.isEdit}
					logProps={props.logProps}
					measureUnit="km"
					sendChange={props.sendChange}
				/>
			</Grid>
			<Grid size={{ sm: 3, xs: 6 }}>
				{/* TOT EXPECTED HOURS */}
				<NumberTextField
					name="wore_length_hours_expected"
					label={t('DETAILS_WORKREPORTS_FIELD_LENGTH_HOURS_EXPECTED')}
					value={props.model.wore_length_hours_expected}
					isEdit={props.isEdit}
					logProps={props.logProps}
					measureUnit="h"
					sendChange={props.sendChange}
				/>
			</Grid>
			<Grid size={{ sm: 3, xs: 6 }}>
				{/* TOT EXPECTED MINUTES */}
				<NumberTextField
					name="wore_length_minutes_expected"
					label={t('DETAILS_WORKREPORTS_FIELD_LENGTH_MINUTES_EXPECTED')}
					value={props.model.wore_length_minutes_expected}
					isEdit={props.isEdit}
					logProps={props.logProps}
					measureUnit="min"
					sendChange={props.sendChange}
				/>
			</Grid>
			<Grid size={12}>
				{/* TAGS */}
				<TagsSelectField
					name="wore_tags"
					label={t('DETAILS_WORKREPORTS_FIELD_TAGS')}
					value={props.model.wore_tags}
					isEdit={props.isEdit}
					logProps={props.logProps}
					sendChange={props.sendChange}
				/>
			</Grid>
		</>
	);
}
